import { CloudCheck, Eye, Key, Lightning, Log, PlusSquare, Power, Skull } from 'phosphor-svelte';
import { default as ArrowDownIcon } from 'phosphor-svelte/lib/ArrowDown';
import { default as ArrowLeftIcon } from 'phosphor-svelte/lib/ArrowLeft';
import { default as ArrowRightIcon } from 'phosphor-svelte/lib/ArrowRight';
import { default as ArrowSquareInIcon } from 'phosphor-svelte/lib/ArrowSquareIn';
import { default as ArrowUpIcon } from 'phosphor-svelte/lib/ArrowUp';
import { default as NotificationIcon } from 'phosphor-svelte/lib/Bell';
import { default as CalendarIcon } from 'phosphor-svelte/lib/Calendar';
import { default as CaretDownIcon } from 'phosphor-svelte/lib/CaretDown';
import { default as CaretLeftIcon } from 'phosphor-svelte/lib/CaretLeft';
import { default as CaretRightIcon } from 'phosphor-svelte/lib/CaretRight';
import { default as CaretUpIcon } from 'phosphor-svelte/lib/CaretUp';
import { default as SortIcon } from 'phosphor-svelte/lib/CaretUpDown';
import { default as CheckIcon } from 'phosphor-svelte/lib/Check';
import { default as CreditCardIcon } from 'phosphor-svelte/lib/CreditCard';
import { default as CurrencyDollarCircleIcon } from 'phosphor-svelte/lib/CurrencyCircleDollar';
import { default as CurrencyDollarIcon } from 'phosphor-svelte/lib/CurrencyDollar';
import { default as dotsThreeVerticalIcon } from 'phosphor-svelte/lib/DotsThreeVertical';
import { default as DownloadIcon } from 'phosphor-svelte/lib/DownloadSimple';
import { default as FilterIcon } from 'phosphor-svelte/lib/FadersHorizontal';
import { default as FileImgIcon } from 'phosphor-svelte/lib/FileImage';
import { default as FlagIcon } from 'phosphor-svelte/lib/Flag';
import { default as FolderIcon } from 'phosphor-svelte/lib/Folder';
import { default as SettingsIcon } from 'phosphor-svelte/lib/GearSix';
import { default as HashIcon } from 'phosphor-svelte/lib/Hash';
import { default as InformationIcon } from 'phosphor-svelte/lib/Info';
import { default as LinkedFileIcon } from 'phosphor-svelte/lib/Link';
import { default as ListIcon } from 'phosphor-svelte/lib/ListDashes';
import { default as SearchIcon } from 'phosphor-svelte/lib/MagnifyingGlass';
import { default as NotesIcon } from 'phosphor-svelte/lib/Notepad';
import { default as EditIcon } from 'phosphor-svelte/lib/PencilSimple';
import { default as IntegrationsIcon } from 'phosphor-svelte/lib/Plug';
import { default as PlusIcon } from 'phosphor-svelte/lib/Plus';
import { default as ReceiptIcon } from 'phosphor-svelte/lib/Receipt';
import { default as InvoiceGenieIcon } from 'phosphor-svelte/lib/Robot';
import { default as SlidersHorizontalIcon } from 'phosphor-svelte/lib/SlidersHorizontal';
import { default as CardViewIcon, default as SquareFourIcon } from 'phosphor-svelte/lib/SquaresFour';
import { default as StarIcon } from 'phosphor-svelte/lib/Star';
import { default as StorefrontIcon } from 'phosphor-svelte/lib/Storefront';
import { default as TrashIcon } from 'phosphor-svelte/lib/Trash';
import { default as PersonProfileIcon, default as UserCircleIcon } from 'phosphor-svelte/lib/UserCircle';
import { default as UsersIcon } from 'phosphor-svelte/lib/Users';
import { default as CloseIcon, default as XIcon } from 'phosphor-svelte/lib/X';
import { default as Icomoon } from './icomoon.svelte';

export type IconType =
  | 'arrow-left'
  | 'arrow-right'
  | 'arrow-up'
  | 'arrow-down'
  | 'arrow-square-in'
  | 'calendar'
  | 'card-view'
  | 'caret-down'
  | 'caret-left'
  | 'caret-right'
  | 'caret-up'
  | 'check'
  | 'close'
  | 'credit-card'
  | 'dots-three-vertical'
  | 'download'
  | 'edit'
  | 'file-img'
  | 'filter'
  | 'flag'
  | 'folder'
  | 'information'
  | 'integrations'
  | 'invoice-genie'
  | 'linked-file'
  | 'list'
  | 'notes'
  | 'notification'
  | 'hash'
  | 'person-profile'
  | 'receipt'
  | 'search'
  | 'settings'
  | 'sliders-horizontal'
  | 'sort'
  | 'star'
  | 'storefront'
  | 'trash'
  | 'square-four'
  | 'users'
  | 'currency-dollar'
  | 'user-circle'
  | 'currency-dollar-circle'
  | 'x'
  | 'plus'
  | 'plus-square'
  | 'icomoon'
  | 'power'
  | 'skull'
  | 'lightning'
  | 'cloud-check'
  | 'log'
  | 'eye';

// Object mapping icon types to their corresponding components
export const Icons = {
  'arrow-left': ArrowLeftIcon,
  'arrow-right': ArrowRightIcon,
  'arrow-up': ArrowUpIcon,
  'arrow-down': ArrowDownIcon,
  'arrow-square-in': ArrowSquareInIcon,
  calendar: CalendarIcon,
  'card-view': CardViewIcon,
  'caret-down': CaretDownIcon,
  'caret-left': CaretLeftIcon,
  'caret-right': CaretRightIcon,
  'caret-up': CaretUpIcon,
  check: CheckIcon,
  close: CloseIcon,
  'credit-card': CreditCardIcon,
  'dots-three-vertical': dotsThreeVerticalIcon,
  download: DownloadIcon,
  edit: EditIcon,
  'file-img': FileImgIcon,
  filter: FilterIcon,
  flag: FlagIcon,
  folder: FolderIcon,
  information: InformationIcon,
  integrations: IntegrationsIcon,
  'invoice-genie': InvoiceGenieIcon,
  'linked-file': LinkedFileIcon,
  list: ListIcon,
  notes: NotesIcon,
  notification: NotificationIcon,
  hash: HashIcon,
  'person-profile': PersonProfileIcon,
  receipt: ReceiptIcon,
  search: SearchIcon,
  settings: SettingsIcon,
  'sliders-horizontal': SlidersHorizontalIcon,
  sort: SortIcon,
  star: StarIcon,
  storefront: StorefrontIcon,
  trash: TrashIcon,
  'square-four': SquareFourIcon,
  users: UsersIcon,
  'currency-dollar': CurrencyDollarIcon,
  'user-circle': UserCircleIcon,
  'currency-dollar-circle': CurrencyDollarCircleIcon,
  x: XIcon,
  plus: PlusIcon,
  'plus-square': PlusSquare,
  icomoon: Icomoon,
  power: Power,
  skull: Skull,
  lightning: Lightning,
  'cloud-check': CloudCheck,
  log: Log,
  eye: Eye,
  'file': FileImgIcon,
  'key': Key,
  'user': UsersIcon
};
